import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesStatusesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-statuses',
	path: '/secure/admin/ViewStatuses.jspa',
};
